import React, { Fragment } from 'react';
import { Route, Switch } from 'react-router-dom';

import CheckInOverviewContainer from 'containers/check-in/overview/check-in-overview-container';
import IdentificationSearchContainer from 'containers/check-in/identification-search/identification-search-container';
import CheckInMemberDetailContainer from 'containers/check-in/member-detail/check-in-member-detail-container';
import EnrollMemberContainer from 'containers/check-in/renew-member/enroll-member-container';

const CheckInView = () => {
  const steps = [{ title: 'Check In', href: '/check-in' }];

  return (
    <Fragment>
      <Switch>
        <Route
          path="/check-in/members/:id/:searchMethod"
          render={props => (<CheckInMemberDetailContainer {...props} steps={steps} />)}
        />
        <Route
          path="/check-in/members/:id"
          render={props => (<CheckInMemberDetailContainer {...props} steps={steps} />)}
        />
        <Route
          exact
          path="/check-in/search"
          render={props => (<IdentificationSearchContainer {...props} steps={steps} />)}
        />
        <Route
          exact
          path="/enroll/members"
          render={props => (<EnrollMemberContainer {...props} steps={steps} />)}
        />
        <Route
          path="/check-in"
          render={props => (<CheckInOverviewContainer {...props} steps={steps} />)}
        />
      </Switch>
    </Fragment>
  );
};

export default CheckInView;
